/**
 * Extracts the first image from a clipboard event (e.g. pasted screenshot) and returns
 * it as a named File suitable for upload. Used by supporting-document upload dialogs.
 */
export function getImageFileFromClipboardEvent(
  e: ClipboardEvent | { clipboardData?: DataTransfer | null }
): File | null {
  const items = e.clipboardData?.items;
  if (!items) return null;
  for (const item of items) {
    if (item.type.startsWith('image/')) {
      const file = item.getAsFile();
      if (file) {
        const ext =
          file.type === 'image/png'
            ? '.png'
            : file.type === 'image/jpeg' || file.type === 'image/jpg'
              ? '.jpg'
              : file.type === 'image/gif'
                ? '.gif'
                : '.png';
        return new File([file], `paste-${Date.now()}${ext}`, { type: file.type });
      }
    }
  }
  return null;
}
